import classNames from 'classnames'

type Props = {
  text?: string
  className?: string
  headingClassName?: string
}

export const CSectionTitle = ({ text, className, headingClassName }: Props) => {
  if (!text) return null

  return (
    <div
      className={classNames(
        'o-container o-container--xl my-6 mt-20',
        className
      )}
    >
      <h2
        className={classNames(
          'text-h4 text-neutral-dark-gray',
          headingClassName
        )}
      >
        {text}
      </h2>
    </div>
  )
}
